<template>
  <div :class="$style.container">
    <div :class="$style.modal">
      Проверьте громкость звука и нажмите ОК, чтобы получать звуковые
      уведомления
      <div @click="$store.commit('setIsNotificationLoad')">ОК</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" module>
@keyframes expand {
  from {
    transform: scale(0.7);
    opacity: 0;
    background: #5470b0;
  }
}
.container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  animation: expand 0.3s ease-in-out;
  background: rgba(0, 0, 0, 0.4);
  transition: opacity 0.3ms;
  z-index: 10;
  .modal {
    transform: translate(-50%, -50%);
    position: absolute;
    top: 50%;
    left: 50%;
    background-color: $bg-secondary;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    border-radius: 1rem;
    padding: 2rem;
    max-width: 27rem;
    @include Title;
    div {
      margin: 2rem 0 0 0;
      background-color: $red-primary;
      color: $t-white;
      padding: 0.5rem 1rem;
      border-radius: 0.5rem;
      cursor: pointer;
    }
  }
}
</style>
